var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 11.4702C16.4205 11.6108 16.4993 11.8014 16.4993 12.0002C16.4993 12.1989 16.4205 12.3895 16.28 12.5302L8.78 20.0302C8.63783 20.1626 8.44978 20.2348 8.25548 20.2313C8.06118 20.2279 7.87579 20.1492 7.73838 20.0118C7.60097 19.8744 7.52225 19.689 7.51883 19.4947C7.5154 19.3004 7.58752 19.1123 7.72 18.9702L14.69 12.0002L7.72 5.03015C7.64631 4.96149 7.58721 4.87869 7.54622 4.78669C7.50523 4.69469 7.48319 4.59538 7.48141 4.49468C7.47963 4.39397 7.49816 4.29394 7.53588 4.20056C7.5736 4.10717 7.62974 4.02233 7.70096 3.95111C7.77218 3.8799 7.85701 3.82375 7.9504 3.78603C8.04379 3.74831 8.14382 3.72978 8.24452 3.73156C8.34523 3.73334 8.44454 3.75538 8.53654 3.79637C8.62854 3.83736 8.71134 3.89647 8.78 3.97015L16.28 11.4702Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.f397c08a87bbddebad36d6a4987bb07b.svg";
export { ForwardRef as ReactComponent };